/* ==========================================================================
   rx-model.js — Rolex product (model / accessory) behaviour.
   Loaded only by sections/rx-model-hero.liquid.

   <rx-lightbox>  desktop gallery lightbox (WP scripts/routes/lightbox.js):
     click an image → full-screen white dialog; prev / next wrap around;
     click the backdrop or the image, the close button or Esc → close.
     Added: ←/→ keys, focus returns to the clicked image.
   Markup contract (see rx-model-hero.liquid):
     <rx-lightbox>
       <button data-rx-lightbox-item data-src="…" data-alt="…">…</button> …
       <dialog>
         <button data-rx-lightbox-close> <button data-rx-lightbox-prev>
         <div data-rx-lightbox-stage></div> <button data-rx-lightbox-next>
       </dialog>
     </rx-lightbox>
   ========================================================================== */
(function () {
  'use strict';

  class RxLightbox extends HTMLElement {
    connectedCallback() {
      this.items = Array.prototype.slice.call(this.querySelectorAll('[data-rx-lightbox-item]'));
      this.dialog = this.querySelector('dialog');
      var stage = this.querySelector('[data-rx-lightbox-stage]');
      if (!this.items.length || !this.dialog || !stage || typeof this.dialog.showModal !== 'function') return;
      // The full-size image is created here (not in the Liquid) so it has no empty src.
      this.image = document.createElement('img');
      this.image.className = 'rx-model-hero__lightbox-img';
      this.image.alt = '';
      stage.appendChild(this.image);
      this.index = 0;

      this.items.forEach(function (item, i) {
        item.addEventListener('click', this.open.bind(this, i));
      }, this);

      var prev = this.querySelector('[data-rx-lightbox-prev]');
      var next = this.querySelector('[data-rx-lightbox-next]');
      var close = this.querySelector('[data-rx-lightbox-close]');
      if (prev) prev.addEventListener('click', this.step.bind(this, -1));
      if (next) next.addEventListener('click', this.step.bind(this, 1));
      if (close) close.addEventListener('click', this.close.bind(this));
      if (this.items.length < 2) {
        if (prev) prev.hidden = true;
        if (next) next.hidden = true;
      }

      this.image.addEventListener('click', this.close.bind(this));
      this.dialog.addEventListener('click', function (event) {
        if (event.target === this.dialog) this.close();
      }.bind(this));
      this.dialog.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') { event.preventDefault(); this.step(-1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); this.step(1); }
      }.bind(this));
      this.dialog.addEventListener('close', function () {
        var item = this.items[this.index];
        if (item) item.focus();
      }.bind(this));
    }

    show(i) {
      var count = this.items.length;
      this.index = (i + count) % count;
      var item = this.items[this.index];
      this.image.src = item.getAttribute('data-src');
      this.image.alt = item.getAttribute('data-alt') || '';
    }

    open(i) {
      this.show(i);
      if (!this.dialog.open) this.dialog.showModal();
    }

    step(delta) {
      this.show(this.index + delta);
    }

    close() {
      if (this.dialog.open) this.dialog.close();
    }
  }

  if (!customElements.get('rx-lightbox')) customElements.define('rx-lightbox', RxLightbox);
})();
